export enum NoteStatus {
  ReadyForSave,
  AlreadySaved,
}
